import { render, staticRenderFns } from "./unclaimed.vue?vue&type=template&id=bb335688&scoped=true"
import script from "./unclaimed.vue?vue&type=script&lang=js"
export * from "./unclaimed.vue?vue&type=script&lang=js"
import style0 from "./unclaimed.vue?vue&type=style&index=0&id=bb335688&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb335688",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb335688')) {
      api.createRecord('bb335688', component.options)
    } else {
      api.reload('bb335688', component.options)
    }
    module.hot.accept("./unclaimed.vue?vue&type=template&id=bb335688&scoped=true", function () {
      api.rerender('bb335688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/unclaimed.vue"
export default component.exports